import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
	for (const carousel of document.querySelectorAll('.swiper.highlights')) {
		const isReviewsBlock = carousel.classList.contains('gs-reviews');
		const count = carousel.querySelectorAll(':scope > .swiper-slide').length;
		if (isReviewsBlock && count < 2) {
			carousel.classList.add('gs-reviews-single');
			continue;
		}

		/* Homepage keeps its fixed counts. A Reviews block never asks for more columns than it has cards. */
		const breakpoints = isReviewsBlock
			? {
				600: {
					slidesPerView: Math.min(2, count),
					navigation: { enabled: count > 2 },
				},
				869: {
					slidesPerView: Math.min(3, count),
					navigation: { enabled: count > 3 },
				},
				1230: {
					slidesPerView: Math.min(4, count),
					navigation: { enabled: count > 4 },
				},
			}
			: {
				600: {
					slidesPerView: 2,
					navigation: { enabled: true },
				},
				869: {
					slidesPerView: 3,
					navigation: { enabled: true },
				},
				1230: {
					slidesPerView: 4,
					navigation: { enabled: false },
				},
			};

		new Swiper(carousel, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 16,
			speed: 250,
			loop: true,
			createElements: true,
			navigation: {
				enabled: true,
			},
			breakpoints,
			...(isReviewsBlock ? { watchOverflow: true } : {}),
		});
	}
});
